import React from 'react';

import PropTypes from 'prop-types';

import { Container, Inner } from './styles';

export const LightFixedBottomPanel = (props) => {
    return (
        <Container>
            <Inner>{props.children}</Inner>
        </Container>
    );
};

LightFixedBottomPanel.propTypes = {
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
};
